(function () {
  function init(root) {
    if (!root || root.dataset.cartCounterInit === '1') return;
    root.dataset.cartCounterInit = '1';

    var valueEl = root.querySelector('[data-cart-counter-value]');
    if (!valueEl) return;

    var min = parseInt(root.getAttribute('data-min'), 10);
    var max = parseInt(root.getAttribute('data-max'), 10);
    if (isNaN(min)) min = 2;
    if (isNaN(max)) max = 6;
    if (min > max) { var t = min; min = max; max = t; }

    valueEl.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-cart-counter-root]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
